<template>
  <div class="topbar">
    <div class="left">
      <!-- [新增] 移动端菜单切换按钮 -->
      <i class="el-icon-s-fold menu-toggle" @click="toggleSidebar" v-if="isMobile"></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item v-if="currentRoute.meta?.title">
          {{ currentRoute.meta.title }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right">
      <el-dropdown @command="handleCommand">
        <span class="user-info">
<!--          <el-avatar :size="32" :src="avatarUrl" />-->
          <span class="username">{{ username }}</span>
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">
            <i class="el-icon-user"></i> 个人中心
          </el-dropdown-item>
          <el-dropdown-item command="password">
            <i class="el-icon-key"></i> 修改密码
          </el-dropdown-item>
          <el-dropdown-item divided command="logout">
            <i class="el-icon-switch-button"></i> 退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Topbar',
  props: {
    collapse: Boolean    // [新增] 接收折叠状态（暂未使用，可扩展）
  },
  data() {
    return {
      isMobile: false,            // [新增] 是否移动端
      screenWidth: window.innerWidth
    }
  },
  computed: {
    currentRoute() {
      return this.$route
    },
    username() {
      return this.$store.state.userInfo?.nickname || '管理员'
    },
    avatarUrl() {
      return this.$store.state.userInfo?.avatar || 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
    }
  },
  created() {
    this.checkMobile()            // [新增]
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    toggleSidebar() {             // [新增] 触发父组件切换
      this.$emit('toggle-sidebar')
    },
    checkMobile() {               // [新增] 屏幕宽度 < 768 视为移动端
      this.screenWidth = window.innerWidth
      this.isMobile = this.screenWidth < 768
    },
    handleResize() {
      this.checkMobile()
    },
    handleCommand(command) {
      switch (command) {
        case 'password':
          this.$router.push('/admin/password')
          break
        case 'logout':
          this.$confirm('确认退出登录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$store.dispatch('logout')
            this.$router.push('/login')
            this.$message.success('已退出')
          }).catch(() => {})
          break
        case 'profile':
          // this.$message.info('个人中心功能开发中...')
          this.$router.push('/admin/profile')
          break
      }
    }
  }
}
</script>

<style scoped>
.topbar {
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  flex-shrink: 0;
}
.left {
  display: flex;
  align-items: center;
  gap: 12px;
}
/* [新增] 汉堡按钮样式，默认隐藏，移动端显示 */
.menu-toggle {
  font-size: 22px;
  color: #333;
  cursor: pointer;
  display: none;
}
@media screen and (max-width: 767px) {
  .menu-toggle {
    display: inline-block;
  }

  .username { /* [新增] 移动端隐藏用户名 */
    display: none;
  }
}
.right {
  display: flex;
  align-items: center;
}
.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 4px;
  transition: background 0.3s;
}
.user-info:hover {
  background: #f0f2f5;
}
.username {
  margin: 0 8px;
  font-size: 14px;
  color: #333;
}
</style>
